"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_83_0_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * map AllowedOeffnungsausrichtungen to AllowedKetteOpeningPrinciples and
 * remove AllowedOeffnungsausrichtungen
 */
const migration_83_0_0 = (json) => {
    if (json.AllowedOeffnungsausrichtungen) {
        if (!json.AllowedKetteOpeningPrinciples) {
            json.AllowedKetteOpeningPrinciples = json.AllowedOeffnungsausrichtungen.map((allowedOeffnungsausrichtung) => (0, echain_shared_articles_1.mapKetteOeffnungsausrichtungToKetteOpeningPrinciple)(allowedOeffnungsausrichtung));
        }
        delete json.AllowedOeffnungsausrichtungen;
    }
    return json;
};
exports.migration_83_0_0 = migration_83_0_0;
//# sourceMappingURL=migration_83_0_0.js.map